import { useKyc } from '@/composables/useKyc';

export default async function (): Promise<boolean> {
  const { $debug } = useNuxtApp();

  try {
    const { isKycIntegrationEnabled } = useKyc();

    if (!isKycIntegrationEnabled.value) {
      if ($debug.isEnabled) {
        console.groupCollapsed('📄 ~ KYC VALIDATION:\n');
        console.debug(
          '📄 ~ isKycIntegrationEnabled:',
          isKycIntegrationEnabled.value,
        );
        coloredDebug(true);
        console.groupEnd();
      }

      return true;
    }

    const { fetchUserProfile } = useUserData();

    await fetchUserProfile();

    const { isApproved, isLivenessPending } = useKyc();
    const { logginAttemptsCount } = useUserValidations();
    const { isNewUserToValidate } = useUserData();
    const { isCheckInactivityEnabled } = useFeatureFlagsJson();

    const checkKycRules = computed(() => {
      if (isNewUserToValidate.value) {
        if (isCheckInactivityEnabled.value) {
          return logginAttemptsCount.value >= 3 ? false : isApproved.value;
        }

        return isApproved.value && !isLivenessPending.value;
      }

      return true;
    });

    if ($debug.isEnabled) {
      console.groupCollapsed('📄 ~ KYC VALIDATION:\n');
      console.debug('📄 ~ logginAttemptsCount:', logginAttemptsCount.value);
      console.debug('📄 ~ isApproved:', isApproved.value);
      console.debug('📄 ~ isLivenessPending:', isLivenessPending.value);
      coloredDebug(checkKycRules.value);
      console.groupEnd();
    }

    return checkKycRules.value;
  } catch (err) {
    if ($debug.isEnabled) {
      console.error(err);
    }

    return false;
  }
}
